import React, { FunctionComponent } from "react";

const AppWindowDisableIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/programing-apps-websites/apps-window/app-window-disable
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.76,8.253v-6a1.5,1.5,0,0,0-1.5-1.5h-18a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M0.76 5.253L21.76 5.253"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11.258 17.253 A6.000 6.000 0 1 0 23.258 17.253 A6.000 6.000 0 1 0 11.258 17.253 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.016 21.495L21.5 13.011"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default AppWindowDisableIcon;
